import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
//import { Router, Route, Switch, Redirect } from "react-router-dom";
import { Route, BrowserRouter as Router,Switch } from 'react-router-dom'

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.2.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import AdminLayout from "layouts/Admin.js";
import Login from './Auth/Login';
const hist = createBrowserHistory();

ReactDOM.render(
  <Router >
    <div>
    <Route exact path='/' component={Login} />
    <Route path='/Login' component={Login} />
    <Switch>
   <Route path='/portal' render={(props) => <AdminLayout {...props} />}/>
    </Switch>
 
    </div>
      {/*<Route path="/admin" render={(props) => <AdminLayout {...props} />} />
      <Redirect to="/admin/dashboard" />*/}
  </Router>,
  document.getElementById("root")
);